/**
 * Converts a string from camelCase or PascalCase to kebab-case.
 * @param {string} string The string to convert.
 * @returns {string} The kebab-cased string.
 */
export const toKebabCase = (string: string): string => {
  // convert from PascalCase/camelCase to kebab-case
  return string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
};
